export default ({ color, typography, fontSize }) => ({
  root: {
    marginBottom: 7,
  },
  title: {
    color: color.pageTitle,
    fontFamily: typography.pageTitle,
    fontSize: fontSize.sectionTitle,
    marginRight: 5,
  },
  description: {
    color: color.bodyText,
    fontSize: fontSize.bodyText,
    margin: '4px 16px 14px 0px',
    fontFamily: typography.bodyText,
  },
  iconColor: {
    color: color.primaryButtonBackground,
    cursor: 'pointer',
    '@media print': {
      display: 'none',
    },
  },
  editText: {
    fontSize: fontSize.xLarge,
    fontFamily: typography.pageTitle,
  },
  inputSection: {
    width: 640,
  },
  inputLabel: {
    fontSize: 10,
    fontFamily: typography.smallText,
    margin: '10px 0px 3px 3px',
  },
  inputBox: {
    width: 624,
    height: 20,
    fontFamily: typography.bodyText,
    fontSize: fontSize.small,
    border: `1px solid ${color.borderColor}`,
    borderRadius: 3,
    marginBottom: 0,
    padding: 8,
  },
  cancelBtn: {
    marginLeft: 20,
  },
  charCount: {
    fontSize: 10,
    margin: '3px 0px 0px 4px',
  },
  descInputBox: {
    height: 56,
    resize: 'none',
  },
  buttonBar: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 30,
  },
  errorMessage: {
    fontSize: 10,
    marginTop: 3,
    color: '#DB4232',
    display: 'block',
  },
  optionalLabel: {
    color: '#AFBACC',
    fontSize: 10,
    float: 'right',
    marginTop: 8,
  },
});